import React from 'react';

export const SkinContext = React.createContext({
  theme: {},
  skin: {},
  updateSkin: () => {},
});
